import { z } from "zod";

export const entityFileTypeSchema = z.object({
  name: z.string(),
  entity: z.string(),
  label: z.string(),
});

export type EntityFileType = z.infer<typeof entityFileTypeSchema>;
